module.exports = __webpack_public_path__ + "static/media/o2Refill.093e718f.mp3";